module.exports = __webpack_public_path__ + "static/media/preview.d1743902.png";